module.exports = __webpack_public_path__ + "static/media/iStock-1171288622.64abdee6.jpg";